import React, { useState, useEffect, useContext } from "react"
import ImageFromDrupal from "../../Image/image-from-drupal"
import {
  backgroundContainer,
  backgroundContainerBis,
  backgroundContainerDetails,
  backgroundWrapper,
  backgroundInputWrapper,
  background,
  backgroundText,
  notificationButton,
  searchButton,
  searchButtonListing,
} from "./header-top.module.scss"
import SearchResults from "../../search-results"
import Icon from "../../Icon/icon"
import root from "window-or-global"
import PropTypes from "prop-types"
import {
  Container,
  SearchButton,
  NotificationButton,
} from "./header-top-styled"
import { NotificationContext } from "gatsby-theme-blank/src/components/notification-context"
import { useBuildData } from "../../../hooks/use-build-data"
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox"

const HeaderTop = ({
  isIndex,
  isDetail,
  message,
  children,
  isGdd,
  inputHidden,
}) => {
  const themeColors = useBuildData().theme_settings.palette
  const options = {
    buttons: {
      backgroundColor: themeColors.b_color_gradients.b_dark,
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: true,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
  }
  const buildInfos = useBuildData().site_settings
  const [results, setResults] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  const { setIsOpen } = useContext(NotificationContext)
  const [localNavigator, setLocalNavigator] = useState(null)

  useEffect(() => {
    if (searchQuery && root.__LUNR__) {
      root.__LUNR__.__loaded.then((lunr) => {
        const refs = lunr.fr.index.search(
          `${searchQuery}^100 ${searchQuery}*^10 ${searchQuery}~2`
        )
        const posts = refs.map(({ ref }) => lunr.fr.store[ref])
        setResults(posts)
      })
    }
  }, [searchQuery])

  useEffect(() => {
    setLocalNavigator(navigator)
  }, [])

  let containerClass
  if (isIndex) {
    containerClass = backgroundContainer
  } else if (isDetail) {
    containerClass = backgroundContainerDetails
  } else {
    containerClass = backgroundContainerBis
  }
  return (
    <>
      {!isGdd && (
        <Container className={containerClass}>
          <div className={backgroundWrapper}>
            {isIndex && (
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <ImageFromDrupal
                    className={background}
                    alt={"Banniere " + buildInfos.website_name}
                    drupal_fid={buildInfos.header_banner.fid}
                    ariaHidden={true}
                  />
                </SRLWrapper>
              </SimpleReactLightbox>
            )}
            {message && (
              <div className={backgroundText}>
                <p>{message}</p>
              </div>
            )}
            {inputHidden ? null : (
              <div className={backgroundInputWrapper}>
                {buildInfos.webpush_enabled && localNavigator?.serviceWorker ? (
                  <NotificationButton
                    aria-label="Bouton de notifications"
                    className={notificationButton}
                    onClick={() => setIsOpen(true)}
                  >
                    <Icon icon="bell" size={16}></Icon>
                  </NotificationButton>
                ) : null}

                <input
                  type="search"
                  id="search-input"
                  name="keywords"
                  onChange={(element) => setSearchQuery(element.target.value)}
                  value={searchQuery}
                  placeholder="Rechercher..."
                  aria-label="Champ de recherche"
                />
                <SearchButton
                  aria-label="Bouton de recherche"
                  className={isIndex ? searchButton : searchButtonListing}
                >
                  <Icon icon="search" size={16}></Icon>
                </SearchButton>
              </div>
            )}
          </div>
        </Container>
      )}
      {searchQuery !== "" && (
        <SearchResults query={searchQuery} resultats={results} />
      )}
      {searchQuery === "" && (
        <div>
          <main>{children}</main>
        </div>
      )}
    </>
  )
}

//-----------------------Prop-Types---------------------------//

HeaderTop.propTypes = {
  children: PropTypes.node.isRequired,
  isIndex: PropTypes.bool,
  isDetail: PropTypes.bool,
  message: PropTypes.string,
  isGdd: PropTypes.bool,
  inputHidden: PropTypes.bool,
}

//-----------------------Prop-Types---------------------------//

export default HeaderTop
